import Cookies from 'js-cookie';

/**
 * Cookie工具类
 */
export const CookieUtil = {
  /**
   * 设置cookie
   * @param key - cookie名称
   * @param value - cookie值
   * @param options - cookie选项(过期时间、路径等)
   */
  set: (key: string, value: string | number | boolean | object, options?: Cookies.CookieAttributes): void => {
    let stringValue: string;
    if (typeof value === 'object') {
      try {
        stringValue = JSON.stringify(value);
      } catch (e) {
        console.error('Cookie值序列化失败:', e);
        stringValue = String(value);
      }
    } else {
      stringValue = String(value);
    }
    Cookies.set(key, stringValue, options);
  },

  /**
   * 获取cookie
   * @param key - cookie名称
   * @param defaultValue - 默认值
   * @returns cookie值或默认值
   */
  get: (key: string, defaultValue: any = ''): any => {
    const value = Cookies.get(key);
    if (value === undefined) return defaultValue;
    
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  },

  /**
   * 获取cookie原始值(不尝试JSON解析)
   * @param key - cookie名称
   * @returns cookie原始值
   */
  getRaw: (key: string): string | undefined => {
    return Cookies.get(key);
  },

  /**
   * 删除cookie
   * @param key - cookie名称
   * @param options - cookie选项(路径等)
   */
  remove: (key: string, options?: Cookies.CookieAttributes): void => {
    Cookies.remove(key, options);
  },

  /**
   * 检查cookie是否存在
   * @param key - cookie名称
   * @returns 是否存在
   */
  exists: (key: string): boolean => {
    return Cookies.get(key) !== undefined;
  }
};

export default CookieUtil; 